/* eslint-disable react/react-in-jsx-scope */
import {
  CButton,
  CCol,
  CForm,
  CFormGroup,
  CFormText,
  CLabel,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CTextarea,
} from '@coreui/react';
import { CustButton } from 'src/reusable';

const DeclineModal = ({
  declinePopup,
  setDeclinePopup,
  declineApprovedStatus,
  setIsDeclinedComment,
  isDeclinedComment,
}) => {
  return (
    <CModal
      show={declinePopup}
      onClose={() => setDeclinePopup(!declinePopup)}
      color="warning"
      style={{ paddingTop: '5%' }}
    >
      <CModalHeader closeButton>
        <CModalTitle>Are you sure you wanna proceed</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CForm
          action=""
          encType="multipart/form-data"
          className="form-horizontal"
        >
          <CFormGroup col >
            <CCol md="3" style={{margin:"auto"}}>
              <CLabel>
                <strong>Kindly justify</strong>
              </CLabel>
            </CCol>
            <CCol xs="12" md="9" style={{margin:"auto"}}>
              <CTextarea
                name="isDeclinedComment"
                value={isDeclinedComment}
                onChange={e => setIsDeclinedComment(e.target.value)}
                rows="3"
                placeholder="Comment..."
                required
              />
              <CFormText>Please enter the justification</CFormText>
            </CCol>
          </CFormGroup>
        </CForm>
      </CModalBody>
      <CModalFooter>
      <CustButton
            type="button"
            name="Submit"
            color="info"
            onClick={e => declineApprovedStatus()}
            className="btn-loading btn-ladda mr-3"
            icon="fa fa-plane"
            isDisabled={isDeclinedComment ? false : true}
            isLoading={false}
          />
        <CButton
          data-toggle="tooltip"
          data-placement="top"
          title="Close"
          color="danger"
          onClick={() => setDeclinePopup(!declinePopup)}
        >
          <i className="fa fa-times" aria-hidden="true"></i>
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default DeclineModal;
